import { AddCircle, CancelOutlined, Edit } from '@mui/icons-material';
import { IconButton, Typography } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import { LightTooltip } from 'lib/designSystem/WhiteTooltip';
import { CompanyComitee, DecisionNode } from 'lib/types/models';
import {
  CategorizedNodes,
  NEW_NODE,
  Node,
  RevisionObjective,
} from 'pages/Settings/Components/Risk/Components/DecisionEngines/components/Create/types';
import React, { useState } from 'react';

import EditAssignation from './components/EditAssignation';
import NewMatrixAssignation from './components/newAssignation';

const useStyles = makeStyles(() =>
  createStyles({
    addContainer: {
      height: '100vh',
      backgroundColor: 'ffffff',
      alignItems: 'center',
      width: '100%',
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  }),
);

type Props = {
  revisionObjective: RevisionObjective;
  decisionNodesAssignation: Node[];
  setDecisionNodesAssignation: (nodes: Node[]) => void;
  decisionNodes: DecisionNode[];
  categorizedNodes: CategorizedNodes;
  setDecisionNodes: (nodes: DecisionNode[]) => void;
  comiteesAvailables: CompanyComitee[];
};

const NodeComponent = ({
  node,
  decisionNodesAssignation,
  setDecisionNodesAssignation,
  setOpenEditNode,
  setEditingNode,
}: {
  node: Node;
  decisionNodesAssignation: Node[];
  setDecisionNodesAssignation: (nodes: Node[]) => void;
  setOpenEditNode: (open: boolean) => void;
  setEditingNode: (node: Node) => void;
}) => {
  const name =
    node.name.length > 40 ? `${node.name.slice(0, 40)}...` : node.name;

  const canDeleteNode = (node: Node) => {
    const haveChildren = decisionNodesAssignation.find(
      (x) => x.fatherNodeId === node.id,
    );
    if (haveChildren) {
      return false;
    }
    return true;
  };

  const deleteNode = (node: Node) => {
    const nodes = decisionNodesAssignation.filter((x) => x.id !== node.id);
    setDecisionNodesAssignation(nodes);
  };

  const handleEditNode = (node: Node) => {
    setEditingNode(node);
    setOpenEditNode(true);
  };

  return (
    <div
      key={node.id}
      style={{
        backgroundColor: '#ffffff',
        padding: '5px 10px',
        borderRadius: '20px',
        margin: '10px 0px',
        border: '1px solid #0F23DF',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <LightTooltip
          title={
            <Typography variant="body1" style={{ padding: '10px' }}>
              {`${node.id} | ${node.name}`}
            </Typography>
          }
          placement="top"
        >
          <Typography variant="body1">
            {node.id} | {name}
          </Typography>
        </LightTooltip>
        <div>
          <IconButton onClick={() => handleEditNode(node)}>
            <Edit color="primary" />
          </IconButton>
          {canDeleteNode(node) && (
            <IconButton onClick={() => deleteNode(node)}>
              <CancelOutlined />
            </IconButton>
          )}
        </div>
      </div>
    </div>
  );
};

const LineNodesConfiguration = (props: Props) => {
  const {
    setDecisionNodesAssignation,
    decisionNodesAssignation,
    decisionNodes,
    comiteesAvailables,
    categorizedNodes,
  } = props;
  const classes = useStyles();
  const [openAddNode, setOpenAddNode] = useState(false);
  const [openEditNode, setOpenEditNode] = useState(false);
  const [newNode, setNewNode] = useState<Node>(NEW_NODE);
  const [editingNode, setEditingNode] = useState<Node>(NEW_NODE);

  return (
    <>
      <div className={classes.container}>
        <div className={classes.addContainer}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="h4">Evaluaciones agregadas</Typography>
            <IconButton onClick={() => setOpenAddNode(true)}>
              <AddCircle color="primary" />
            </IconButton>
          </div>
          <div style={{ padding: '20px 0px' }}>
            {decisionNodesAssignation.map((node, index) => {
              return (
                <NodeComponent
                  key={index}
                  node={node}
                  decisionNodesAssignation={decisionNodesAssignation}
                  setDecisionNodesAssignation={setDecisionNodesAssignation}
                  setOpenEditNode={setOpenEditNode}
                  setEditingNode={setEditingNode}
                />
              );
            })}
          </div>

          {decisionNodesAssignation.length === 0 && (
            <div style={{ padding: '20px 0px' }}>
              <Typography variant="body1" gutterBottom>
                No hay nodos agregados
              </Typography>
            </div>
          )}
          {openAddNode && (
            <NewMatrixAssignation
              newNode={newNode}
              setNewNode={setNewNode}
              openAddNode={openAddNode}
              setOpenAddNode={setOpenAddNode}
              decisionNodes={decisionNodes}
              decisionNodesAssignation={decisionNodesAssignation}
              setDecisionNodesAssignation={setDecisionNodesAssignation}
              comiteesAvailables={comiteesAvailables}
              categorizedNodes={categorizedNodes}
            />
          )}
        </div>
      </div>
      <EditAssignation
        openEditNode={openEditNode}
        setOpenEditNode={setOpenEditNode}
        editingNode={editingNode}
        setEditingNode={setEditingNode}
        decisionNodes={decisionNodes}
        categorizedNodes={categorizedNodes}
        decisionNodesAssignation={decisionNodesAssignation}
        setDecisionNodesAssignation={setDecisionNodesAssignation}
      />
    </>
  );
};

export default LineNodesConfiguration;
